// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { actions } from '../duck';
import Cargo from '../components/Cargo';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    localeState: state.locale,
    user: state.auth.user,
    isPostingContactMessage: state.cargo.isPostingContactMessage,
    postContactMessageSuccess: state.cargo.postContactMessageSuccess,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Cargo);



// WEBPACK FOOTER //
// ./src/modules/cargo/container/CargoContainer.js